// R-KEY (Section 5): the canonical key list and the sharp → flat normalizer.
// Mirrors backend/routes/services_logic.py canonical_key(); keep them in step.
// Fix 6B B1 (owner ruling 2026-09-30): keys use flats; both spellings are accepted.

export const MAJOR_KEYS = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
export const MINOR_KEYS = MAJOR_KEYS.map(k => `${k}m`);
export const KEYS = [...MAJOR_KEYS, ...MINOR_KEYS];

const SHARP_TO_FLAT = { 'C#': 'Db', 'D#': 'Eb', 'F#': 'Gb', 'G#': 'Ab', 'A#': 'Bb' };
const KEY_RE = /^([A-Ga-g])([#♯]|[b♭])?\s*(m|[mM][iI][nN](?:[oO][rR])?)?$/;

// Canonical key string for `raw`, or null when unknown ("Hb", "Cb", "E#", "").
export function normalizeKey(raw) {
  if (raw === null || raw === undefined) return null;
  const m = String(raw).trim().match(KEY_RE);
  if (!m) return null;
  const letter = m[1].toUpperCase();
  const acc = m[2] || '';
  const minor = m[3] ? 'm' : '';
  let base;
  if (acc === '#' || acc === '♯') base = SHARP_TO_FLAT[`${letter}#`] || null;
  else if (acc === 'b' || acc === '♭') base = `${letter}b`;
  else base = letter;
  if (!base || !MAJOR_KEYS.includes(base)) return null;
  return base + minor;
}
